import { useCallback, useState } from "react";
import sdk from "@/sdk";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import { GroupDetailsParams } from "@/pages/user/group-details";

export function useReleaseHold() {
  const [loading, setLoading] = useState(false);
  const [currentPurchaseId, setCurrentPurchaseId] = useState<
    string | undefined
  >();

  const queryClient = useQueryClient();

  const { _id } = useParams<GroupDetailsParams>();

  // 63c4c6e8ce4cdaa92faa7438

  const releaseHold = useCallback(async (purchaseId: string) => {
    setLoading(true);
    setCurrentPurchaseId(purchaseId);
    try {
      // Assuming you have a GraphQL client set up
      await sdk.releaseHoldAmount({ _id: purchaseId });
      queryClient.refetchQueries(["balance", "user:" + _id]);
    } catch (error: any) {
      console.error("Error releasing hold amount:", error);
      alert(error.message || "Error releasing hold amount");
    } finally {
      setLoading(false);
      setCurrentPurchaseId(undefined);
    }
  }, []);

  return { loading, currentPurchaseId, releaseHold };
}
